// extracted by mini-css-extract-plugin
export default {"placementAdTypeTable":"nQLqT9VlYSPHJboJ7Xm2","tableContainer":"ncn72tPB8bJsKEvpeIhJ"};